import React from "react";
import { Parallax } from "react-parallax";
import Image from "../../assets/current-openings-bg.jpg";
import { Link } from "react-router-dom";

const CurrentOpenings = () => {
  return (
    <>
      <Parallax bgImage={Image} blur={{ min: -3, max: 1 }} strength={50}>
        <section className="current-openings md:py-24 py-12">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <h2 className="md:text-4xl text-3xl font-avenirHeavy leading-normal text-white text-center">
              Current openings
            </h2>
            <div className="py-10 w-12/12	mx-auto">
              <div className="flex flex-row items-center md:pt-10 pt-5">
                <div className="grid md:grid-cols-2 grid-cols-1 md:w-4/4 md:gap-4 gap-8 w-full">

                  <div className="rounded bg-white p-6 current-opening">
                    <h5 className="text-xl md:text-sm font-avenirHeavy text-blue-800">
                      Cloud Architect
                    </h5>
                    <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3 leading-6">
                      As a Cloud Architect, you will be responsible for designing, building, and optimizing our cloud-based solutions to meet the needs of our clients and stakeholders.
                    </p>
                    <span className="md:text-13 text-base font-normal text-Gray-400">
                      <span className="font-semibold">7+</span> years experience
                    </span>
                  </div>

                  <div className="rounded bg-white p-6 current-opening">
                    <h5 className="md:text-sm text-lg font-semibold text-blue-800">
                      Senior Data Engineer
                    </h5>
                    <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3 leading-6">
                      As a software engineer, you will be responsible for new
                      development activities in the area. You will be a key…
                    </p>
                    <span className="md:text-13 text-base font-normal text-Gray-400">
                      <span className="font-semibold">6+</span> years experience
                    </span>
                  </div>

                  <div className="rounded bg-white p-6 current-opening">
                    <h5 className="md:text-sm text-lg font-semibold text-blue-800">
                      Senior Full Stack .Net Software Engineer
                    </h5>
                    <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3 leading-6">
                      As a software engineer, you will be responsible for new
                      development activities in the area. You will be a key…
                    </p>
                    <span className="md:text-13 text-base font-normal text-Gray-400">
                      <span className="font-semibold">6+</span> years experience
                    </span>
                  </div>

                  <div className="rounded bg-white p-6 current-opening">
                    <h5 className="md:text-sm text-lg font-semibold text-blue-800">
                       Senior Full Stack Java Software Engineer
                    </h5>
                    <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3 leading-6">
                      As a software engineer, you will be responsible for new
                      development activities in the area. You will be a key…
                    </p>
                    <span className="md:text-13 text-base font-normal text-Gray-400">
                      <span className="font-semibold">6+</span> years experience
                    </span>
                  </div>

                  <div className="rounded bg-white p-6 current-opening">
                    <h5 className="md:text-sm text-lg font-semibold text-blue-800">
                       Senior Full Stack Web Developer with Python 
                    </h5>
                    <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3 leading-6">
                      As a Software Engineer, you will create, enhance, and maintain top-notch software solutions while collaborating with diverse teams to deliver scalable applications. Your contributions will drive our development initiatives and business forward.
                    </p>
                    <span className="md:text-13 text-base font-normal text-Gray-400">
                      <span className="font-semibold">7+</span> years experience
                    </span>
                  </div>


                  <div className="rounded bg-white p-6 current-opening">
                    <h5 className="md:text-sm text-lg font-semibold text-blue-800">
                       DevOps Engineer
                    </h5>
                    <p className="md:text-13 text-base font-normal font-opensans text-Gray-400 py-3 leading-6">
                      As a DevOps Engineer, you will design, implement, and maintain cutting-edge CI/CD pipelines and infrastructure automation solutions. Collaborating with diverse teams, your efforts will streamline software delivery and drive innovation for our clients.
                    </p>
                    <span className="md:text-13 text-base font-normal text-Gray-400">
                      <span className="font-semibold">5+</span> years experience
                    </span>
                  </div>

                </div>
              </div>

           

            </div>
            <p className="text-white text-sm font-normal text-center">
              Visit our careers section to learn more on current openings
            </p>
            <div className="text-center">
              <Link to="/career">
                <button className="brand-primary-btn mt-8">Work @ 2M</button>
              </Link>
            </div>
          </div>
        </section>
      </Parallax>
    </>
  );
};

export default CurrentOpenings;
